export const INVOICE_FEATURE = 'cal-txp-invoice';
export const SERVICE_RESERVATION_ADAPTIVE_FEATURE = 'cal-txp-serviceReservationAdaptive';
